<template>
  <div>
    <head>
      <link rel="stylesheet" :href="css">
    </head>
    <div class="container-fluid">
      <div class="row gameplay_pg">
        <div class="iframe_section">
          <iframe :src="'static/mini_games/puzzle_game/'+puzzleGameCss+'_gameplay.html'" frameborder="0"></iframe>
        </div>
      </div>
    </div>
    <component :is="currentModal"></component>
  </div>
</template>

<script>
/* eslint no-console: "off", no-use-before-define: ["error", { "variables": false }] */
/* postgame.html */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import ResultOfAddOnGame from './ResultOfAddOnGame';

export default {
  name: 'add-on-game-puzzle',
  data() {
    return {
      currentModal: null,
      gameId: null,
      css: '',
    };
  },
  created() {
    if (!this.$route.params.fromPreGame) this.$router.push('/home');
    console.log('in AddOnGame created hook');
    this.css = localStorage.getItem('locale') === ('AR' || 'KU') ?
      `../../../../../static/mini_games/puzzle_game/${this.puzzleGameCss}_AR.css` :
      `../../../../../static/mini_games/puzzle_game/${this.puzzleGameCss}.css`;
    // eslint-disable-next-line
    $('.header-main').hide();
    // if (!this.$route.params.gameId) this.$router.push('/home');
    // this.gameId = this.$route.params.gameId;
  },
  mounted() {
    window.addEventListener('message', this.receiveMessage);
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('game', [
      'setBonusAddOnGameDataSuccess',
    ]),
    receiveMessage(event) {
      if (event.data.isPlayed) {
        window.removeEventListener('message', this.receiveMessage);
        // route to net page // modal with these data from index.html (can include if user scored or no)
        console.log('EPPPP: ', event.data);
        const payload = { success: event.data.puzzleSolved };
        this.setBonusAddOnGameDataSuccess(payload);
        this.currentModal = ResultOfAddOnGame;
        this.showHideModal();
      }
    },
    showHideModal() {
      this.$nextTick(() => {
        /* eslint-disable */
        $('.modal,.modal-overlay,.overlay').fadeIn(200);
        $("body").addClass("modal-open");
        $('.modal-close,.modal-overlay,.overlay,.btn_close').click(() => {
          $(".popup_box").fadeOut(200);
          $(".overlay").fadeOut(200);
          $('.modal, .modal-overlay').fadeOut();
          $("body").removeClass("modal-open");
          console.log('user has not leveled up, going to home page');
          /* eslint-disable */
          this.currentModal = null;
          if (this.getUserAvailableGames === 0) {
            sessionStorage.removeItem('zeroBalancePopUp');
          }
          this.getUserLoginDetails().then(() => {
            this.$router.push('/home');
          });
        });
      });
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'puzzleGameCss',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('common', [
      'getUserAvailableGames',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/addongamepuzzle/AddOnGamePuzzle.vue